<div class="mega-menu__content" [class.mega-menu__content--store]="isStoreMenu">

  <a
    [routerLink]="config.mainUrl"
    (click)="onLinkClick()"
    class="shrink-0 self-start pr-8 no-underline cursor-pointer transition-opacity duration-200 hover:opacity-80 md:self-center md:pr-12">
    <h3
      class="font-display uppercase text-[32px] md:text-[40px] text-rojo-brillante font-normal select-none tracking-tight leading-none">
      {{ config.mainTitle }}
    </h3>
  </a>

  @if (isStoreMenu) {
    <div class="store-preview">
      @if (config.columns.length) {
        <nav class="store-preview__categories" aria-label="Categorías de productos">
          @for (column of config.columns; track column.title; let index = $index) {
            <a [routerLink]="column.url" [queryParams]="column.queryParams" (click)="onLinkClick()"
              (mouseenter)="selectColumn(index)" (focus)="selectColumn(index)"
              class="store-preview__category"
              [class.store-preview__category--active]="activeColumn() === index">
              {{ column.title }}
            </a>
          }
        </nav>

        @if (config.columns[activeColumn()]; as column) {
          <div class="store-preview__heading">
            <span>Selección de {{ column.title }}</span>
            <a [routerLink]="column.url" [queryParams]="column.queryParams" (click)="onLinkClick()">
              Ver categoría <span aria-hidden="true">→</span>
            </a>
          </div>
          <div class="store-preview__products">
            @for (link of column.links; track link.label) {
              @if (!link.isEllipsis) {
                <a [routerLink]="link.url" (click)="onLinkClick()" class="store-preview__product">
                  <span>{{ link.label }}</span>
                  <span class="store-preview__arrow" aria-hidden="true">↗</span>
                </a>
              }
            }
            @if (!column.links.length) {
              <p class="store-preview__empty">Próximamente nuevos productos.</p>
            }
          </div>
        }
      } @else {
        <div class="store-preview__loading" role="status">
          <span></span><span></span><span></span>
          <p>Cargando catálogo…</p>
        </div>
      }
    </div>
  } @else {
  <div class="mega-menu__columns">
    @for (column of config.columns; track column.title) {
    <div class="relative flex w-full min-w-0 max-w-48 flex-col items-start pl-6">
      @if (column.isDividerBefore) {
      <div class="absolute -left-4 top-0 h-57.5 w-px! bg-rojo-brillante"></div>
      }

      @if (column.url) {
        <a [routerLink]="column.url" [queryParams]="column.queryParams" (click)="onLinkClick()"
          class="mb-3 font-display text-[25px]! font-normal uppercase tracking-wide text-rojo-brillante select-none text-left transition-opacity hover:opacity-75 md:text-xl">
          {{ column.title }}
        </a>
      } @else {
        <h4
          class="mb-3 font-display text-[25px]! font-normal uppercase tracking-wide text-rojo-brillante select-none text-left md:text-xl">
          {{ column.title }}
        </h4>
      }

      <div class="flex flex-col items-start gap-2">
        @for (link of column.links; track link.label) {
        @if (link.isEllipsis) {
          <span class="font-display text-sm font-normal tracking-wide leading-snug text-azul-edil md:text-[15px]" aria-label="Hay más productos">…</span>
        } @else {
          <a [routerLink]="link.url" [queryParams]="link.queryParams" [fragment]="link.fragment" (click)="onLinkClick()"
            class="font-display text-sm font-normal uppercase tracking-wide leading-snug text-azul-edil! transition-colors duration-200 hover:text-rojo-brillante text-left whitespace-nowrap md:text-[15px]">
            {{ link.label }}
          </a>
        }
        }
      </div>
    </div>
    }
  </div>
  }

</div>
